// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ZD_v","imageUploader":"EGiftCard_imageUploader__3WSq1"};